import { FC } from 'react'
import styled from 'styled-components'
import Carousel from 'nuka-carousel'
import { ICarousel } from 'src/types'

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const HorizontalCarouselWrapper = styled.div`
  margin-bottom: 48px;
  height: 400px;

  .slider-slide {
    height: 400px !important;
  }
`

interface Props {
  horizontalCarousels: ICarousel[]
}

const HorizontalCarousel: FC<Props> = ({ horizontalCarousels }) => (
  <HorizontalCarouselWrapper>
    <Carousel
      autoplay
      autoplayInterval={2000}
      transitionMode="fade"
      wrapAround
      withoutControls
    >
      {horizontalCarousels.slice(0, 10).map((image) => (
        <Img key={image.title} src={image.imageUrl} alt={image.title} />
      ))}
    </Carousel>
  </HorizontalCarouselWrapper>
)

export default HorizontalCarousel
